export const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "white" : "black",
    backgroundColor: state.isFocused && "#00968f",
  }),

  menuList: (provided, state) => ({
    ...provided,
    borderRadius: "0px 0px 12px 12px",
    margin: 0,
  }),
  input: (provided, state) => ({
    ...provided,
    backgroundColor: "transparent",
    borderRadius: "12px",
    borderColor: "transparent",
    color: "black",
    marginTop: 0,
    padding: 0,
    margin: 0,
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#FFFFFF",
    borderRadius: "0px 0px 12px 12px",
    marginTop: 0,
    color: "black",
  }),

  placeholder: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen && "#FFFFFF",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen && "#FFFFFF",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen && "#FFFFFF",
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen && "#FFFFFF",
  }),
  container: (provided, state) => ({
    ...provided,
    borderRadius: "40px",
    marginTop: 0,
  }),

  singleValue: (provided, state) => ({
    ...provided,
    opacity: state.isDisabled ? 0.5 : 1,
    transition: "opacity 300ms",
  }),
};
